import React from 'react';

import { AlineTooltip, ToolbarButton } from 'src/components';
import { ClearFormatIcon } from 'src/components/icons/ClearFormatIcon';
import { useEditingDisabled } from 'src/store/document/selectors';
import { makeStyles } from 'tss-react/mui';

export const clearFormattingAttribute = 'toolbar-button-clear-formatting';

const useStyles = makeStyles()(theme => ({
  button: {
    height: 32,
    margin: theme.spacing(0, 0.25),
    width: 32,
  },
}));

export function ClearFormatButton(): JSX.Element {
  const { classes } = useStyles();
  const disabled = useEditingDisabled();

  return (
    <AlineTooltip arrow placement="bottom" title="Clear formatting">
      <div>
        <ToolbarButton
          className={classes.button}
          data-cy={clearFormattingAttribute}
          disabled={disabled}
        >
          <ClearFormatIcon />
        </ToolbarButton>
      </div>
    </AlineTooltip>
  );
}
